import { render, staticRenderFns } from "./ai-algorithms-page.html?vue&type=template&id=49c40545&scoped=true&external"
import script from "./ai-algorithms-page.js?vue&type=script&lang=js&external"
export * from "./ai-algorithms-page.js?vue&type=script&lang=js&external"
import style0 from "./ai-algorithms-page.scss?vue&type=style&index=0&id=49c40545&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c40545",
  null
  
)

export default component.exports